import React from 'react';
import PageSection from '../PageSection/PageSection';

function Highlights(props){
	return (
		<PageSection data={{Header:true,Title:'Highlights',hide_content:false}} layout='HORIZONTAL4' last={true}>
			{props.children}
		</PageSection>
	)
};

export default Highlights;